import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientKpisPage from "@/pages/client/ClientKpisPage";

export const Route = createFileRoute("/client/contracts/$contractId/kpis")({
  head: () => pageHead("Client · Contracts · Kpis", "AKIVA client · contracts · kpis portal.", "/client/contracts/$contractId/kpis", true),
  component: ClientKpisPage,
});
